export interface ICaratSize {
  mm:number,
  ct:number
}

export interface ICaratConversionChart {
  stoneType:('Natural Diamond'|'Lab Grown Diamond'|'Black Diamond'|'Sapphire'|'Ruby'|'White Diamond')[],
  stoneCut:('Brilliant'|'Princess'|'Baguette')[],
  chart:ICaratSize[]
}

export const CARAT_CONVERSION_CHARTS:ICaratConversionChart[] = [
  {
    stoneType: ['White Diamond', 'Natural Diamond','Lab Grown Diamond', 'Black Diamond'],
    stoneCut: ['Brilliant'],
    chart: [
      // 1.3mm = 0.01ct
      { mm: 1.3, ct: 0.01 },

      // 1.5mm = 0.015ct
      { mm: 1.5, ct: 0.015 },

      // 1.7mm = 0.02ct
      { mm: 1.7, ct: 0.02 },

      // 1.9mm = 0.03ct
      { mm: 1.9, ct: 0.03 },

      // 2.1mm = 0.04ct
      { mm: 2.1, ct: 0.04 },
      
      // 2.3mm = 0.05ct
      { mm: 2.3, ct: 0.05 },

      // 2.4mm = 0.06ct
      { mm: 2.4, ct: 0.06 },

      // 2.6mm = 0.07ct
      { mm: 2.6, ct: 0.07 },

      // 2.7mm = 0.08ct
      { mm: 2.7, ct: 0.08 },

      // 2.8mm = 0.09ct
      { mm: 2.8, ct: 0.09 },

      // 2.9mm = 0.10ct
      { mm: 2.9, ct: 0.10 },

      // 3.0mm = 0.11ct
      { mm: 3.0, ct: 0.11 }
    ]
  },

  {
    stoneType: ['White Diamond','Natural Diamond','Lab Grown Diamond', 'Black Diamond'],
    stoneCut: ['Princess'],
    chart: [
      // 2.0mm = 0.05ct
      { mm: 2.0, ct: 0.05 },

      // 2.1mm = 0.06ct
      { mm: 2.1, ct: 0.06 },

      // 2.2mm = 0.07ct
      { mm: 2.2, ct: 0.07 },

      // 2.3mm = 0.08ct
      { mm: 2.3, ct: 0.08 },

      // 2.4mm = 0.09ct
      { mm: 2.4, ct: 0.09 },
      
      // 2.5mm = 0.10ct
      { mm: 2.5, ct: 0.10 },

      // 2.6mm = 0.12ct
      { mm: 2.6, ct: 0.12 },

      // 2.7mm = 0.13ct
      { mm: 2.7, ct: 0.13 },

      // 2.8mm = 0.15ct
      { mm: 2.8, ct: 0.15 }
    ]
  },

  {
    stoneType: ['Ruby', 'Sapphire'],
    stoneCut: ['Brilliant'],
    chart: [
      // 1.3mm = 0.02ct
      { mm: 1.3, ct: 0.02 },

      // 1.5mm = 0.025ct
      { mm: 1.5, ct: 0.025 },

      // 1.7mm = 0.03ct
      { mm: 1.7, ct: 0.03 },

      // 1.9mm = 0.04ct
      { mm: 1.9, ct: 0.04 },

      // 2.1mm = 0.05ct
      { mm: 2.1, ct: 0.05 },

      // 2.3mm = 0.06ct
      { mm: 2.3, ct: 0.06 },

      // 2.4mm = 0.07ct
      { mm: 2.4, ct: 0.07 },

      // 2.5mm = 0.08ct
      { mm: 2.5, ct: 0.08 },

      // 2.6mm = 0.09ct
      { mm: 2.6, ct: 0.09 },

      // 2.7mm = 0.10ct
      { mm: 2.7, ct: 0.10 },

      // 2.8mm = 0.11ct
      { mm: 2.8, ct: 0.11 },

      // 2.9mm = 0.12ct
      { mm: 2.9, ct: 0.12 },

      // 3.0mm = 0.13ct
      { mm: 3.0, ct: 0.13 },
    ]
  },


]